<template>
  <v-card class="rounded-xl attachment-repair-file" :border="false" :elevation="0">
    <v-col cols="12">
      <p class="title">
        {{ $t('RENTAL_FILE_ATTACHMENT.TITLE') }}
      </p>
      <p class="sub-title" v-if="!checkPermission(['DISTRIBUTOR_RENTAL_READ'])">
        {{ $t('RENTAL_FILE_ATTACHMENT.PERMISSION.VIEW_ATTACHMENT_DENIED') }}
      </p>
    </v-col>
    <v-row class="pa-3" no-gutters>
      <template v-if="checkPermission(['DISTRIBUTOR_RENTAL_READ'])">
        <!--Card CGV-->
        <v-col cols="2" md="1"
               class="image-container"
               @click.stop.prevent="getCGVPdf()"
        >
          <img alt="pdf-svg"
               src="@/assets/icons/file/pdf.svg"
               class="image-pdf"
          />
          <div class="download-content">
            <img alt="download-svg"
                 src="@/assets/icons/file/download.svg"
                 class="image-download"
            />
          </div>
          <p class="content-text">
            {{ $t('RENTAL_FILE_ATTACHMENT.CARD.CGV') }}
          </p>
        </v-col>

        <!--Card list of Attachment-->
        <template :key="attachment.technical_id"
                  v-for="attachment of attachmentList"
        >
          <v-col cols="2" md="1"
                 class="image-container"
                 @click.stop.prevent="downloadFiles(attachment.file_path)"
          >
            <img alt="pdf-svg"
                 src="@/assets/icons/file/pdf.svg" class="image-pdf"
            />
            <div class="download-content">
              <img alt="download-svg"
                   src="@/assets/icons/file/download.svg"
                   class="image-download"
              />
            </div>
            <p class="content-text">
              {{ attachment.name }}
            </p>
          </v-col>
        </template>
      </template>

      <!--Card add attachment-->
      <template v-if="checkPermission(['DISTRIBUTOR_RENTAL_UPDATE'])">
        <v-col cols="2" md="1"
               class="add-attachment"
        >
          <div @click.stop.prevent="openInputModal()"
               class="add-attachment-content"
          >
            <img class="cross-round-svg"
                 alt="cross-round-svg"
                 src="@/assets/icons/file/cross_round.svg"
            />
          </div>
        </v-col>
      </template>
    </v-row>
  </v-card>
  <UploadRentalAttachmentModal ref="uploadRentalAttachmentModal" />
</template>

<script>
import { displayToast, checkPermission, handleResponseError } from '@/components/utils/globalFunction'
import UploadRentalAttachmentModal
  from '@/components/modal/rentalModule/rentalFile/UploadRentalAttachmentModal.vue'
import RentalPdfService from '@/services/rentalModule/RentalPdfService'
import RentalFileService from '@/services/rentalModule/RentalFileService'
import { RentalFileSummary } from '@/models/rentalModule/RentalFileSummary'

export default {
  name: 'AttachmentRentalFile',
  components: { UploadRentalAttachmentModal },
  props: {
    rentalFileSummary: RentalFileSummary
  },
  data() {
    return {
      attachmentList: []
    }
  },
  async created() {
    if (this.checkPermission(['DISTRIBUTOR_RENTAL_READ'])) {
      await this.getRentalFileAttachment()
    }
  },
  watch: {
    rentalFileSummary() {
      this.getRentalFileAttachment()
    }
  },
  methods: {
    checkPermission,
    openInputModal() {
      this.$refs.uploadRentalAttachmentModal.show({
        rentalFileId: this.rentalFileSummary.rental_file_technical_id,
        title: this.$t('RENTAL_FILE_ATTACHMENT.CARD.ADD_ATTACHMENT'),
        fileNameTitle: this.$t('RENTAL_FILE_ATTACHMENT.MODAL.FILE_NAME'),
        fileTitle: this.$t('RENTAL_FILE_ATTACHMENT.MODAL.FILE')
      }).then(async (result) => {
        if (result.confirmed) {
          if (this.checkPermission(['DISTRIBUTOR_RENTAL_READ'])) {
            await this.getRentalFileAttachment()
          }
        }
      })
    },
    async downloadFiles(file_url) {
      if (!this.checkPermission(['DISTRIBUTOR_RENTAL_READ'])) {
        displayToast(this.$t('RENTAL_FILE_ATTACHMENT.PERMISSION.PRINT_ATTACHMENT_DENIED'), 'error')
      } else {
        if (file_url) {
          const a = document.createElement('a')
          a.style.display = 'none'
          a.href = file_url
          document.body.appendChild(a)
          a.click()
          await new Promise((resolve) => setTimeout(resolve, 500))
          document.body.removeChild(a)
        }
      }
    },
    async getCGVPdf() {
      if (!this.checkPermission(['DISTRIBUTOR_RENTAL_READ'])) {
        displayToast(this.$t('RENTAL_FILE_ATTACHMENT.PERMISSION.PRINT_ATTACHMENT_DENIED'), 'error')
      } else {
        try {
          this.loading = true
          const response = await RentalPdfService.getRentalContractPdf("useless-id")
          const url = window.URL.createObjectURL(new Blob([response]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'cgv_location_'
            + this.rentalFileBoomerangId + '.pdf')
          document.body.appendChild(link)
          link.click()
        } catch (error) {
          handleResponseError(error)
        } finally {
          this.loading = false
        }
      }
    },
    async getRentalFileAttachment() {
      try {
        const response = await RentalFileService
          .getAttachmentFileList(this.rentalFileSummary.rental_file_technical_id)
        this.attachmentList = response.item_list
      } catch (error) {
        handleResponseError(error)
      }
    },
  }
}
</script>

<style scoped>
.add-attachment {
  margin-left: 10px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 20px;
  border: 1px dashed #559A1B;
  cursor: pointer;
}

.add-attachment-content {
  align-items: center;
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  border-radius: 50px;
  box-shadow: 6px 6px 12px 0px rgba(218, 218, 218, 0.40);
}

.cross-round-svg {
  width: 12px;
  height: 12px;
}

.attachment-repair-file {
  min-height: 196px;
}

.v-card {
  padding: 10px 20px;
}

.content-text {
  text-align: center;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.content-text:first-letter {
  text-transform: uppercase;
}

.image-container {
  cursor: pointer;
  margin-bottom: 10px;
  max-height: 140px;
  position: relative;
}

.image-pdf {
  display: flex;
  margin: auto auto 30px;
  position: relative;
  width: 56px;
  height: 56px;
}

.download-content {
  position: absolute;
  top: 50px;
  left: 24px;
  width: 32px;
  height: 32px;
  background: white;
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-download {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 12px;
  height: 12px;
}

.title {
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.link-black {
  color: rgba(0, 0, 0, 0.87);
  text-decoration: unset;
}

.sub-title {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  display: flex;
}
</style>
